import React from"react";
import SupportBase from"./Support";

const SupportStudent = () => {
 return <SupportBase userType="student" />;
};

export default SupportStudent;



